module.exports = __webpack_public_path__ + "eca7b505fb7ef8eea65af0fb7301d30f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bristol_myers_squibb_2022_chart.png
// module id = 1642
// module chunks = 0